import "../styles/style.scss";
import './parts/_parts';
import "../styles/style.scss";
import './parts/_parts';

if (typeof wp !== 'undefined' && wp.blocks) {
    import('./editor/_paragraph-variation.js');
}

document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector(".container-header-menu");
    const headerMobile = document.querySelector(".container-header-menu-mobile");
    const entete = document.querySelector(".background-accueil");

    const headerHeight = header?.getBoundingClientRect().height || 0;
    const headerMobileHeight = headerMobile?.getBoundingClientRect().height || 0;

    // On prend la hauteur non nulle (desktop prioritaire, sinon mobile)
    const marginTop = headerHeight || headerMobileHeight;

    const target = entete || document.querySelector(".hero-section");
    if (target) {
        target.style.marginTop = `${marginTop}px`;
    }

    const closeAllSubMenus = (exceptMenu = null) => {
        document.querySelectorAll(
            ".mw-header-primary-menu__wrapper:not(.mw-header-primary-menu__wrapper--level-0), " +
            ".mw-secondary-menu__wrapper:not(.mw-secondary-menu__wrapper--level-0)"
        ).forEach(menu => {
            if (menu !== exceptMenu) {
                menu.style.display = "none";
                const prevBtn = menu.previousElementSibling;
                if (prevBtn?.tagName === "BUTTON") {
                    prevBtn.setAttribute("aria-expanded", "false");
                }
                const parentLi = menu.closest("li");
                if (parentLi) parentLi.classList.remove("is-open");
            }
        });

        document.querySelectorAll(
            ".mw-header-primary-menu__item button, " +
            ".mw-secondary-menu__item button"
        ).forEach(btn => {
            const controlled = document.getElementById(btn.getAttribute("aria-controls"));
            if (controlled && controlled !== exceptMenu) {
                btn.setAttribute("aria-expanded", "false");
            }
        });
    };

    const closeAllMobileSubMenus = (exceptMenu = null) => {
        document.querySelectorAll(".mw-menu-mobile__sub-container").forEach(sub => {
            if (sub !== exceptMenu) {
                sub.style.display = "none";
                const parentItem = sub.closest(".mw-menu-mobile__item");
                if (parentItem) parentItem.classList.remove("is-open");
            }
        });
    };


    const setParentLevel1Width = (el, open, prefix) => {
        const parentLvl1Menu = el.closest(`.${prefix}__wrapper--level-1`);
        if (!parentLvl1Menu) return;

        const li = el.closest("li");
        if (!li) { parentLvl1Menu.style.width = ''; return; }

        if (open) {
            if (li.classList.contains(`${prefix}__item--level-2`)) parentLvl1Menu.style.width = '800px';
            else if (li.classList.contains(`${prefix}__item--level-3`)) parentLvl1Menu.style.width = '995px';
            else parentLvl1Menu.style.width = '';
        } else {
            if (li.classList.contains(`${prefix}__item--level-3`)) parentLvl1Menu.style.width = '800px';
            else parentLvl1Menu.style.width = '';
        }
    };


    const primaryTrigger = document.querySelector('.mw-header-primary-menu__trigger');
    const siteLogo = document.querySelector('.mw-site-logo');
    const headerContainer = document.querySelector('header > .mw-container > .mw-container:last-child');
    const searchButton = document.querySelector('.mw-search-button');

    if (primaryTrigger) {
        primaryTrigger.addEventListener('click', () => {
            const isExpanded = primaryTrigger.getAttribute("aria-expanded") !== "false";
            const controlElement = document.getElementById(primaryTrigger.getAttribute('aria-controls'));

            if (controlElement) {
                if (isExpanded) {
                    primaryTrigger.classList.remove('mw-header-primary-menu__close-btn');
                    controlElement.classList.remove('active');
                    siteLogo?.classList.remove('active');
                    headerContainer?.classList.remove('active');
                    if (searchButton) searchButton.style.display = 'inline-flex';
                } else {
                    primaryTrigger.classList.add('mw-header-primary-menu__close-btn');
                    controlElement.classList.add('active');
                    siteLogo?.classList.add('active');
                    headerContainer?.classList.add('active');
                    if (searchButton) searchButton.style.display = 'none';
                }
                primaryTrigger.setAttribute("aria-expanded", !isExpanded);
            }
        });
    }


    const secondaryTrigger = document.querySelector('.mw-secondary-menu__trigger');

    if (secondaryTrigger) {
        secondaryTrigger.addEventListener('click', () => {
            const isExpanded = secondaryTrigger.getAttribute("aria-expanded") !== "false";
            const controlElement = document.getElementById(secondaryTrigger.getAttribute('aria-controls'));

            if (controlElement) {
                if (isExpanded) {
                    secondaryTrigger.classList.remove('mw-secondary-menu__close-btn');
                    controlElement.classList.remove('active');
                    siteLogo?.classList.remove('active');
                    if (searchButton) searchButton.style.display = 'inline-flex';
                } else {
                    secondaryTrigger.classList.add('mw-secondary-menu__close-btn');
                    controlElement.classList.add('active');
                    siteLogo?.classList.add('active');
                    if (searchButton) searchButton.style.display = 'none';
                }
                secondaryTrigger.setAttribute("aria-expanded", !isExpanded);
            }
        });
    }


    const allDesktopButtons = document.querySelectorAll(
        ".mw-header-primary-menu__item button, " +
        ".mw-secondary-menu__item button"
    );

    allDesktopButtons.forEach(button => {
        button.addEventListener("click", function (event) {
            event.stopPropagation();

            const subMenuId = this.getAttribute("aria-controls");
            const subMenu = document.getElementById(subMenuId);
            const isOpen = this.getAttribute("aria-expanded") === "true";
            const parentLi = this.closest("li");

            const isPrimary = !!this.closest(".mw-header-primary-menu");
            const prefix = isPrimary ? "mw-header-primary-menu" : "mw-secondary-menu";

            closeAllSubMenus(isOpen ? null : subMenu);

            if (!isOpen) {
                subMenu.style.display = "block";
                this.setAttribute("aria-expanded", "true");
                if (parentLi) {
                    parentLi.classList.add("is-open");
                    setParentLevel1Width(this, true, prefix);
                }
            } else {
                subMenu.style.display = "none";
                this.setAttribute("aria-expanded", "false");
                if (parentLi) {
                    parentLi.classList.remove("is-open");
                    setParentLevel1Width(this, false, prefix);
                }
            }
        });
    });

    document.addEventListener("click", function (event) {
        if (
            !event.target.closest(".mw-header-primary-menu") &&
            !event.target.closest(".mw-secondary-menu")
        ) {
            closeAllSubMenus();
        }
    });



    // Géré par le viewScript du bloc menu-mobile (view.js)


    let lastScrollTop = 0;

    window.addEventListener('scroll', () => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (Math.abs(scrollTop - lastScrollTop) > 5) {
            closeAllSubMenus();
            closeAllMobileSubMenus();
        }
    });

    const counters = document.querySelectorAll(".counter-value");
    const duration = 1500;
    
    const startCounter = (counter) => {
        const targetValue = counter.textContent.trim();
        const digits = targetValue.split("");
        const decimalIndex = digits.findIndex(c => c === '.' || c === ',');
        const totalDigits = digits.filter(c => /\d/.test(c)).length;

        counter.innerHTML = "";

        let digitOrdinal = 0;

        digits.forEach((digit, i) => {
            const container = document.createElement("span");
            container.classList.add("digit-con");

            const inner = document.createElement("span");
            inner.classList.add("digit");

            if (!/\d/.test(digit)) {
            inner.textContent = digit;
            container.appendChild(inner);
            counter.appendChild(container);
            return;
        }

        digitOrdinal += 1;
        let shouldBold = false;

        if (decimalIndex >= 0) {
            if (i > decimalIndex) {
                const posAfterDecimal = i - decimalIndex;
                if (posAfterDecimal === 3 || posAfterDecimal === 4 || posAfterDecimal === 5) {
                    shouldBold = true;
                }
            } else {
                shouldBold = false;
            }
        } else {
            if (digitOrdinal > totalDigits - 3) {
                shouldBold = true;
            }
        }

            for (let n = 0; n < 20; n++) {
                const span = document.createElement("span");
                span.textContent = n % 10;
                inner.appendChild(span);
            }

            container.appendChild(inner);
            counter.appendChild(container);

            const endDigit = parseInt(digit, 10);
            const steps = endDigit === 0 ? 10 : endDigit;
            const increment = inner.firstElementChild.offsetHeight || 100;
            const totalShift = steps * increment;
            const delay = (digitOrdinal - 1) * 150;
            const start = performance.now();

            if (shouldBold) {
                // inner.style.fontWeight = "600";
            } else if (endDigit !== 0) {
                inner.style.fontWeight = "600";
            }

            const animate = (time) => {
                const elapsed = time - start - delay;
                if (elapsed < 0) return requestAnimationFrame(animate);
                const progress = Math.min(elapsed / duration, 1);
                const currentShift = totalShift * progress;
                inner.style.transform = `translateY(-${currentShift}px)`;
                if (progress < 1) requestAnimationFrame(animate);
            };

            requestAnimationFrame(animate);
        });
    };

    const observerCompteur = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    startCounter(entry.target);
                    observerCompteur.unobserve(entry.target);
                }
            });
        },
        { threshold: 0.4 }
    );

    counters.forEach((counter) => observerCompteur.observe(counter));

    const accordionAccueil = document.querySelector(".mw-accordion-accueil .mw-accordion .mw-accordion__container");
    if(accordionAccueil){
        const firstItem = accordionAccueil.firstElementChild;
        const itemContent = firstItem.querySelector(".mw-accordion__content");
        firstItem.classList.add("mw-accordion__item--active");
        itemContent.classList.remove("hide");
        itemContent.classList.add("show");
    }

    
});

